import { Spinner } from "react-bootstrap"

export const FullScreenLoader = ({ message }: { message: string }) => {


    return (
        <div className="position-fixed text-center bg-full-screen-loader">
            <div>
                <Spinner variant="dark" />
            </div>
            <div className="text-dark">
                {message}
            </div>
        </div>
    )
}